import script from "./RecentTransactionsInfoPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecentTransactionsInfoPanel.vue?vue&type=script&setup=true&lang=ts"

import "./RecentTransactionsInfoPanel.vue?vue&type=style&index=0&id=6f7d73d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7d73d2"]])

export default __exports__